import React from 'react';
import { Star, BarChart2, PieChart, LineChart, TrendingUp } from 'lucide-react';
import type { ReportType, ReportData } from '../../types/reports';

interface ReportsListProps {
  type: ReportType;
  reports: ReportData[];
  onSelect: (report: ReportData) => void;
  onToggleFavorite: (reportId: string) => void;
}

const ReportsList: React.FC<ReportsListProps> = ({
  type,
  reports,
  onSelect,
  onToggleFavorite
}) => {
  const getReportIcon = (reportType: ReportType) => {
    switch (reportType) {
      case 'sales':
        return <BarChart2 className="h-6 w-6 text-blue-500" />;
      case 'financial':
        return <TrendingUp className="h-6 w-6 text-green-500" />;
      case 'inventory':
        return <PieChart className="h-6 w-6 text-purple-500" />;
      case 'customers':
        return <LineChart className="h-6 w-6 text-orange-500" />;
      case 'fiscal':
        return <BarChart2 className="h-6 w-6 text-red-500" />;
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {reports.map((report) => (
        <div
          key={report.id}
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow cursor-pointer"
          onClick={() => onSelect(report)}
        >
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center space-x-3">
              {getReportIcon(report.type)}
              <h3 className="text-lg font-medium text-gray-900">
                {report.title}
              </h3>
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onToggleFavorite(report.id);
              }}
              className={`p-1 rounded-full hover:bg-gray-100 ${
                report.favorite ? 'text-yellow-400' : 'text-gray-400'
              }`}
            >
              <Star className="h-5 w-5" />
            </button>
          </div>

          <p className="text-sm text-gray-500 mb-4">
            {report.description}
          </p>

          <div className="text-xs text-gray-400">
            Última atualização: {new Date(report.createdAt).toLocaleString()}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReportsList;